import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryConfig } from "@/lib/react-query";
import type { Plan } from "@/types/plans.types";
import { apiPaths } from "@/config/paths";
import { features } from "@/config/features";
import { publicApi } from "@/lib/api-client";

interface GetPlansParams {
  useCase: string;
}

export const getPlans = (): Promise<{
  data: Plan[];
}> => {
  return publicApi.get(apiPaths.plans.getPlans.getPath());
};

export const getPlanQueryOptions = (params: { data: GetPlansParams }) => {
  return queryOptions({
    queryKey: ["Plans", params.data.useCase],
    queryFn: () => getPlans(),
    select: data => data.data.filter(plan => plan.useCase === params.data.useCase || plan.isFree === true),
  });
};

type UsePlanOptions = {
  queryConfig?: QueryConfig<typeof getPlanQueryOptions>;
  data: GetPlansParams;
};

export const usePlans = ({ queryConfig, data }: UsePlanOptions = { data: { useCase: "personal" } }) => {
  return useQuery({
    ...getPlanQueryOptions({ data }),
    ...queryConfig,
    // Legacy MembershipTiers plans; platform envs have none, so the request only 500s.
    enabled: !features.platformSubscriptionsEnabled,
  });
};

export const useFreePlan = () => {
  const { data, isLoading, isError } = usePlans({
    data: { useCase: "personal" },
  });
  const freePlan = data?.find(plan => plan.isFree);

  return {
    data: freePlan,
    isLoading,
    isError,
  };
};
